import React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

import { useCurrentTracklog } from 'ff/debrief/hooks';
import { useDebriefModal } from 'ff/debrief/modalManager';
import { useDeleteSharedTracklogMutation } from 'ff/debrief/features/TracklogApi';
import DebriefDialogTitle from 'ff/debrief/components/modals/DebriefDialogTitle';

const RemoveShareModal = () => {
    const { isOpen, close } = useDebriefModal('RemoveShare');
    const { tracklog: tl, deselectShared } = useCurrentTracklog();

    const [deleteSharedTracklog, deleteShareStatus] =
        useDeleteSharedTracklogMutation();

    const handleSubmit = () => {
        deleteSharedTracklog(tl.shareDetailsSummary.shareId);
        deselectShared();
        handleClose();
    };

    const handleClose = () => {
        close();
    };

    if (!tl) return null;
    return (
        <Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
            <DebriefDialogTitle onClose={handleClose}>
                Remove Shared Track Log
            </DebriefDialogTitle>
            <DialogContent>
                <Typography>
                    The selected Track Log will be removed from all devices on
                    your account. To view it again, the owner will need to
                    re-share it with you.
                </Typography>
                <Typography>
                    Are you sure you want to remove this shared Track Log?
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={handleClose}
                    disabled={deleteShareStatus.isLoading}
                    variant="outlined"
                    color="info"
                    size="small"
                >
                    Cancel
                </Button>
                <Button
                    onClick={handleSubmit}
                    disabled={deleteShareStatus.isLoading}
                    variant="contained"
                    color="error"
                    size="small"
                >
                    Remove
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default RemoveShareModal;
